import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';
import { observer } from 'mobx-react';
import { RevenueAttributionStore } from '../stores/revenue-attribution.store';

export const RevenueAttributionPage = provide({ singletons: [RevenueAttributionStore] })(
    observer(() => {
        const [{ source, data, basename }] = useDependencies(RevenueAttributionStore);

        return <Loader src={source} data={data} basename={basename} />;
    }),
);
